/** InsCoder WANG.J 2026-05-27 B + Lazy load inactive collection tabs **/
(function() {
  var SECTION_SELECTOR = '.cust-multiple-collection[data-section-id]';

  function getSections(context) {
    var scope = context || document;
    var sections = [];

    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(scope.querySelectorAll(SECTION_SELECTOR)));
    }

    return sections;
  }

  function getOneLineNum(section) {
    var parsedValue = parseInt(section.dataset.oneLineNum, 10);
    return Number.isNaN(parsedValue) ? 4 : parsedValue;
  }

  function escapeAttributeValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return value.replace(/"/g, '\\"');
  }

  function getContent(section, blockId) {
    return section.querySelector('.cmc-content[data-block="' + escapeAttributeValue(blockId) + '"]');
  }

  function getBlockProductsData(section, blockId) {
    var dataNode = section.querySelector('.cmc-block-products-data[data-block="' + escapeAttributeValue(blockId) + '"]');

    if (!dataNode) {
      return [];
    }

    try {
      return JSON.parse(dataNode.textContent.trim() || '[]');
    } catch (error) {
      return [];
    }
  }

  function getBooleanDataValue(section, key) {
    return section.dataset[key] === 'true';
  }

  function isAsyncLoadEnabled(section) {
    return getBooleanDataValue(section, 'enableAsyncLoad');
  }

  function getStatusNode(content) {
    var statusNode = content.querySelector('.cmc-content__status');

    if (!statusNode) {
      statusNode = document.createElement('div');
      statusNode.className = 'cmc-content__status';
      statusNode.setAttribute('aria-live', 'polite');
      content.appendChild(statusNode);
    }

    return statusNode;
  }

  function setStatus(content, message) {
    var statusNode = getStatusNode(content);
    statusNode.textContent = message || '';
    statusNode.hidden = !message;
  }

  function initProductCards(content) {
    var productCards = content.querySelectorAll('product-card');

    productCards.forEach(function(card) {
      if (typeof card.initSwiper === 'function') {
        card.initSwiper();
      }
    });
  }

  function initSwiper(content, oneLineNum) {
    if (!window.Swiper || !content || content.dataset.swiperInitialized === 'true') {
      return;
    }

    var swiperWrapper = content.querySelector('.swiper-wrapper');
    var nextButton = content.querySelector('.swiper-button-next');
    var prevButton = content.querySelector('.swiper-button-prev');
    var scrollbar = content.querySelector('.swiper-scrollbar');

    if (!swiperWrapper || !nextButton || !prevButton || !scrollbar) {
      return;
    }

    var swiperInstance = new Swiper(content, {
      spaceBetween: 8,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },
      scrollbar: {
        el: scrollbar
      },
      breakpoints: {
        0: {
          slidesPerView: 2.1
        },
        769: {
          slidesPerView: oneLineNum,
          slidesPerGroup: oneLineNum,
          allowTouchMove: false
        }
      }
    });

    content.dataset.swiperInitialized = 'true';
    content.cmcSwiper = swiperInstance;
  }

  function buildProductCardUrl(productUrl) {
    var requestUrl = new URL(productUrl, window.location.origin);
    requestUrl.searchParams.set('view', 'cust-multiple-collection-card');
    return requestUrl.toString();
  }

  function normalizeFetchedCard(cardElement, section) {
    var mediaSize = section.dataset.mediaSize || 'adapt';
    var showVendor = getBooleanDataValue(section, 'showVendor');
    var addImagePadding = getBooleanDataValue(section, 'addImagePadding');
    var showImageOutline = getBooleanDataValue(section, 'showImageOutline');

    cardElement.querySelectorAll('.media').forEach(function(mediaItem) {
      mediaItem.classList.remove('media--adapt', 'media--square', 'media--portrait');
      mediaItem.classList.add('media--' + mediaSize);

      if (mediaSize !== 'adapt') {
        mediaItem.style.removeProperty('padding-bottom');
      }
    });

    cardElement.querySelectorAll('.card__inner .swiper-wrapper').forEach(function(wrapper) {
      wrapper.classList.toggle('card__media-full-spacer', addImagePadding);
    });

    var cardNode = cardElement.querySelector('.card.card--product');
    if (cardNode) {
      cardNode.classList.toggle('card--outline', showImageOutline);
    }

    if (!showVendor) {
      var infoWrapper = cardElement.querySelector('.card-information__wrapper');
      if (infoWrapper) {
        var vendorHidden = infoWrapper.querySelector('.visually-hidden');
        var vendorCaption = infoWrapper.querySelector('.caption-with-letter-spacing.light');

        if (vendorHidden) {
          vendorHidden.remove();
        }

        if (vendorCaption) {
          vendorCaption.remove();
        }
      }
    }
  }

  function buildContentMarkup(slidesMarkup) {
    return [
      '<div class="swiper-wrapper">',
      slidesMarkup,
      '</div>',
      '<div class="swiper-bottom">',
      '<div class="swiper-scrollbar"></div>',
      '<div class="swiper-buttons">',
      '<div class="swiper-button-prev swiper-btn">',
      '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">',
      '<path d="M18.6665 10.6755L13.0665 16.2755L18.6665 21.8755" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg>',
      '</div>',
      '<div class="swiper-button-next swiper-btn">',
      '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">',
      '<path d="M13.3335 21.342L18.9335 15.742L13.3335 10.142" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg>',
      '</div>',
      '</div>',
      '</div>'
    ].join('');
  }

  async function fetchProductCardMarkup(productUrl, blockId, section) {
    var response = await fetch(buildProductCardUrl(productUrl), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch product card HTML');
    }

    var responseMarkup = await response.text();
    var safeMarkup = responseMarkup.replace(/__CMC_INSTANCE__/g, blockId);
    var parsedDocument = new DOMParser().parseFromString(safeMarkup, 'text/html');
    var cardElement = parsedDocument.querySelector('product-card');

    if (!cardElement) {
      throw new Error('Product card markup was not returned');
    }

    normalizeFetchedCard(cardElement, section);
    return '<div class="cmc-item grid__item swiper-slide">' + cardElement.outerHTML + '</div>';
  }

  /** InsCoder WANG.J 2026-05-29 B + Limit concurrent product card requests per tab **/
  async function fetchProductCardsMarkup(productUrls, blockId, section) {
    var slidesMarkup = new Array(productUrls.length);
    var nextIndex = 0;
    var concurrency = Math.min(4, productUrls.length);

    async function worker() {
      while (nextIndex < productUrls.length) {
        var currentIndex = nextIndex;
        nextIndex += 1;

        try {
          slidesMarkup[currentIndex] = await fetchProductCardMarkup(productUrls[currentIndex], blockId, section);
        } catch (error) {
          slidesMarkup[currentIndex] = '';
          console.warn('Failed to load product card for tab block:', blockId, error);
        }
      }
    }

    await Promise.all(
      Array.from({ length: concurrency }, function() {
        return worker();
      })
    );

    return slidesMarkup.filter(Boolean).join('');
  }
  /** InsCoder WANG.J 2026-05-29 E + Limit concurrent product card requests per tab **/

  function setActiveState(section, blockId) {
    section.querySelectorAll('.tab-title[data-block]').forEach(function(tab) {
      var isActive = tab.dataset.block === blockId;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    section.querySelectorAll('.cmc-content[data-block]').forEach(function(content) {
      var isActive = content.dataset.block === blockId;
      content.classList.toggle('active', isActive);
      content.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      content.hidden = !isActive;
    });
  }

  async function loadBlockContent(section, blockId) {
    var currentContent = getContent(section, blockId);
    var productUrls = getBlockProductsData(section, blockId);

    if (!isAsyncLoadEnabled(section)) {
      return currentContent;
    }

    if (!currentContent || currentContent.dataset.loaded === 'true') {
      return currentContent;
    }

    if (currentContent.dataset.loading === 'true') {
      return currentContent;
    }

    currentContent.dataset.loading = 'true';
    currentContent.classList.add('is-loading');
    setStatus(currentContent, 'Loading products...');

    try {
      if (!productUrls.length) {
        currentContent.innerHTML = '<div class="cmc-content__status">No products available.</div>';
        currentContent.dataset.loaded = 'true';
        currentContent.dataset.loading = 'false';
        currentContent.classList.remove('is-loading');
        currentContent.classList.remove('is-load-error');
        return currentContent;
      }

      var slidesMarkup = await fetchProductCardsMarkup(productUrls, blockId, section);

      if (!slidesMarkup) {
        throw new Error('Product cards could not be loaded');
      }

      currentContent.innerHTML = buildContentMarkup(slidesMarkup);
      currentContent.dataset.loaded = 'true';
      currentContent.dataset.loading = 'false';
      currentContent.classList.remove('is-loading');
      currentContent.classList.remove('is-load-error');
      initSwiper(currentContent, getOneLineNum(section));
      initProductCards(currentContent);
      return currentContent;
    } catch (error) {
      currentContent.dataset.loading = 'false';
      currentContent.classList.remove('is-loading');
      currentContent.classList.add('is-load-error');
      setStatus(currentContent, 'Unable to load products right now.');
      return currentContent;
    }
  }

  async function activateBlock(section, blockId) {
    setActiveState(section, blockId);

    var content = getContent(section, blockId);
    if (!content) {
      return;
    }

    if (content.dataset.loaded !== 'true') {
      content = await loadBlockContent(section, blockId);
      setActiveState(section, blockId);
    }

    if (content && content.dataset.loaded === 'true') {
      setStatus(content, '');
      initSwiper(content, getOneLineNum(section));
      initProductCards(content);

      if (content.cmcSwiper && typeof content.cmcSwiper.update === 'function') {
        content.cmcSwiper.update();
      }
    }
  }

  function bindSection(section) {
    if (section.dataset.cmcInitialized === 'true') {
      return;
    }

    section.dataset.cmcInitialized = 'true';

    section.addEventListener('click', function(event) {
      var swiperNav = event.target.closest('.swiper-nav');
      if (swiperNav && section.contains(swiperNav)) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      var tab = event.target.closest('.tab-title[data-block]');
      if (!tab || !section.contains(tab)) {
        return;
      }

      event.preventDefault();
      activateBlock(section, tab.dataset.block);
    });

    section.addEventListener('keydown', function(event) {
      var currentTab = event.target.closest('.tab-title[data-block]');
      if (!currentTab || !section.contains(currentTab)) {
        return;
      }

      var tabs = Array.prototype.slice.call(section.querySelectorAll('.tab-title[data-block]'));
      var currentIndex = tabs.indexOf(currentTab);
      var nextIndex = -1;

      if (event.key === 'ArrowRight') {
        nextIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = currentIndex <= 0 ? tabs.length - 1 : currentIndex - 1;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex === -1 || !tabs[nextIndex]) {
        return;
      }

      event.preventDefault();
      tabs[nextIndex].focus();
      activateBlock(section, tabs[nextIndex].dataset.block);
    });

    var initialContent = section.querySelector('.cmc-content.active[data-loaded="true"]') || section.querySelector('.cmc-content[data-loaded="true"]');
    if (initialContent) {
      initSwiper(initialContent, getOneLineNum(section));
      initProductCards(initialContent);
    }
  }

  function initSections(context) {
    getSections(context).forEach(function(section) {
      bindSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initSections(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initSections(event.target);
  });
})();
/** InsCoder WANG.J 2026-05-27 E + Lazy load inactive collection tabs **/
